module.exports = __webpack_public_path__ + "img/Weilin robotic arm control software.a189fa2c.jpg";